<template>
  <div style="width:100%">
    <img :src="src" alt="" id="image" height="550" />
  </div>
</template>

<script>
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
export default {
  name: 'ClipImg',
  data() {
    return {
      cropper: null,
      cropData: null
    }
  },
  props: ['src'],
  mounted() {
    this.$nextTick(() => {
      const that = this
      const image = document.getElementById('image')
      // eslint-disable-next-line no-unused-vars
      this.cropper = new Cropper(image, {
        viewMode: 1,
        // zoomOnWheel: false,
        toggleDragModeOnDblclick: false,
        crop(event) {
          that.cropData = event.detail
        }
      })
    })
  }
}
</script>

<style></style>
